import {SepaMandateList, SepaMandateRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {Box, TableCell} from "@mui/material";
import {SoftChip} from "../../../../components/kit";
import {dateToString} from "../../../../components/utils/dates";
import {MANDATE_STATUS} from "../sepa-remittance/labels";
import {useSearchParams} from "react-router-dom";


export const SepaMandateListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(SepaMandateRestControllerApiFactory);
	const [searchParams] = useSearchParams();

	const customerIdValue = searchParams.get("customerId");
	const customerId = customerIdValue ? Number(customerIdValue) : undefined;

	const listConfig: AppListConfig<SepaMandateList> = {
		title: "Mandatos SEPA",
		onClick: "/app/admin/billing/sepa-mandate",
		headers: [
			{title: "Referencia"},
			{title: "Cliente"},
			{title: "Titular"},
			{title: "IBAN"},
			{title: "Firma"},
			{title: "Estado"},
		],
		decorator: (bean: SepaMandateList) => (
			<>
				<TableCell sx={{whiteSpace: "nowrap"}}>{bean.reference}</TableCell>
				<TableCell>{bean.customer?.shortName || ""}</TableCell>
				<TableCell>{bean.debtorName}</TableCell>
				<TableCell sx={{whiteSpace: "nowrap", fontFamily: "monospace"}}>{bean.iban}</TableCell>
				<TableCell sx={{whiteSpace: "nowrap"}}>{bean.signatureDate ? dateToString(bean.signatureDate) : "—"}</TableCell>
				<TableCell sx={{whiteSpace: "nowrap"}}>
					{/* El vigente se ve de un vistazo entre el historial. */}
					<SoftChip tone={MANDATE_STATUS[bean.status || ""]?.tone || "neutral"}
							  label={MANDATE_STATUS[bean.status || ""]?.label || bean.status}/>
					{bean.revokedDate && (
						<Box component={"span"} color={"text.secondary"} sx={{ml: 1, fontSize: 12}}>
							{dateToString(bean.revokedDate)}
						</Box>
					)}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			// Parámetros POSICIONALES: page, size, sort, customerId, status, term, showDismissed.
			return ctrl.pageSepaMandate(
				currentPage,
				size,
				undefined,
				customerId,
				undefined,
				term,
				showDismissed
			);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
